<template>

  <div>
    <PageHeader :title="'Receive Study Notes'"></PageHeader>

    <div class="main-content container-fluid xs-pt-0">
      <div class="row">
        <div class="col-xs-12">
          <Panel class="panel panel-default panel-border-color panel-border-color-primary xs-mt-0">
            <PanelBody v-if="receivedShares.length > 0" class="xs-pt-20 xs-pb-20">
              <ReceiveChapterRow v-for="share in receivedShares" :share="share"></ReceiveChapterRow>

              <div class="xs-pt-20">
                <strong>Import selected study notes to:</strong><br />
                <!-- Select or create subject -->
                <div class="row xs-mt-10">
                  <div v-if="subjects && subjects.length && !newSubjectTitle" class="col-md-6">
                    <label for="lectureNoteSubject">Place in existing subject</label>
                    <select v-model="selectedSubjectId" class="form-control" id="lectureNoteSubject" v-on:change="newSubjectTitle = ''">
                      <option></option>
                      <option v-for="subject in subjects" :value="subject.id">{{ subject.title }}</option>
                    </select>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="newLectureNoteSubject"><span v-if="subjects && subjects.length && !newSubjectTitle">Or </span>Create a new subject</label>
                      <input v-model="newSubjectTitle" type="text" id="newLectureNoteSubject" class="form-control" placeholder="Subject Name">
                    </div>
                  </div>
                </div><!-- /.row -->
                <div class="pull-right buttons">
                  <button class="btn btn-danger btn-xl" v-on:click="declineSelected()" :disabled="selectedShareImportIds.length <= 0 || saving">Decline selected</button>
                  <button class="btn btn-primary btn-xl" v-on:click="importSelected()" :disabled="selectedShareImportIds.length <= 0 || !validSubject || saving">Import selected</button> &nbsp;
                </div>
              </div>
            </PanelBody>
            <PanelBody v-else  class="xs-pt-20 xs-pb-20">
              <div class="alert alert-warning">No study notes to import</div>
            </PanelBody>
          </Panel>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.main-content -->
  </div><!-- /.div -->
</template>
<script>
  import _ from 'underscore'
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
  import ReceiveChapterRow from './ReceiveChapterRow'

export default {
  components: {
    ReceiveChapterRow
  },
  created() {
    this.getAllReceivedShares();
    this.getSubjects();
  },
  methods: {
    ...mapActions([
      'getAllReceivedShares',
      'getSubjects',
    ]),
    importSelected() {
      if (this.selectedShareImportIds.length > 0 && this.validSubject) {
        if (this.newSubjectTitle) {
          var self = this;
          this.$store.dispatch('createSubject', {
            subject: { title: this.newSubjectTitle },
            callback: function (error, obj) {
              self.acceptSelected(obj);
            }
          });
        } else {
          this.acceptSelected();
        }
      }
    },
    acceptSelected(subject) {
      if (subject) {
        this.selectedSubjectId = subject.id;
      }
      
      if (this.selectedSubjectId) {
        this.saving = true;
        for (let id of this.selectedShareImportIds) {
          this.$http.post('shares/' + id + '/accept', { subject_id: this.selectedSubjectId }, {
          }).then((res) => {
            if (res.body.success) {
              this.$store.commit('REMOVE_RECEIVED_SHARE', { id: id });
              this.$store.commit('REMOVE_NOTIFICATION_WITH_ITEM', { itemId: id, itemType: 'share' });
              Toast.success('Lecture notes imported');
            }
            this.saving = false;
          }, (res) => {
            Toast.error('Failed to accept share request')
            this.saving = false;
          })
        }
      }
    },
    declineSelected() {
      if (confirm('Are you sure you want to decline ' + this.selectedShareImportIds.length + ' share requests?'))
      for (let id of this.selectedShareImportIds) {
        this.$store.dispatch('deleteShare', {
          id: id
        });
        this.$store.commit('REMOVE_NOTIFICATION_WITH_ITEM', { itemId: id, itemType: 'share' });
      }
    },
    updateSelected(share) {
      if (share.selected) {
        share.selected = false;
      } else {
        share.selected = true;
      }
    },
  },
  data() {
    return {
      selectedSubjectId: null,
      newSubjectTitle: null,
      saving: false,
    }
  },
  computed: {
    ...mapGetters({
      receivedShares: 'receivedShares',
      subjects: 'allSubjects',
      selectedShareImportIds: 'selectedShareImportIds',
    }),
    ...mapState([
      
    ]),

    validSubject() {
      if (this.selectedSubjectId || this.newSubjectTitle) return true;
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .buttons {margin-top:20px;}
</style>



// WEBPACK FOOTER //
// ReceiveChapter.vue?54c06301